import Logo from "../../assets/img/new_footer_logo.svg";
import FacebookIcon from "../../assets/img/facebook.svg";
import Insta from "../../assets/img/insta.svg";
import Twiter from "../../assets/img/tiktok_icon.svg";
import Youtube from "../../assets/img/youtube.svg";
import Heart from "../../assets/img/heart.svg";
import BackgroundSection from "../BackgroundSection";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeUp, fadeIn, stagger, VIEWPORT_REVEAL } from "../../motion";

function Footer() {
  return (
    <>
      <div className="footer">
        <div className="container">
          <motion.div
            className="footer-logo text-center"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={VIEWPORT_REVEAL}
          >
            <a href="/"><img src={Logo} alt="" width={280} height={52} /></a>
          </motion.div>
          <motion.div
            className="footer-social-icon text-center"
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={VIEWPORT_REVEAL}
          >
            <ul>
              <motion.li variants={fadeIn}><a href="#."><img src={FacebookIcon} alt="" /> </a></motion.li>
              <motion.li variants={fadeIn}><a href="https://www.instagram.com/lovehappinessapp?igsh=bzBwc2d1bHE5aWtl&utm_source=qr" target="_blank"><img src={Insta} alt="" /> </a></motion.li>
              <motion.li variants={fadeIn}><a href="https://www.tiktok.com/@lovehappinessapp?_r=1&_t=ZN-97j3236nZCg" target="_blank"><img src={Twiter} alt="" /> </a></motion.li>
              <motion.li variants={fadeIn}><a href="#."><img src={Youtube} alt="" /> </a></motion.li>
            </ul>
          </motion.div>
          <div className="copyright-text text-center">
            <p>
              <Link
                to={"/terms"}
              >
                Terms
              </Link>
              <Link
                to={"/privacy"}
              >Privacy</Link>
              <Link
                to={"/child_safety"}
              >Child Safety</Link>
              <Link
                to={"/contact"}
              >Contact</Link>
            </p>
            <p>© {new Date().getFullYear()} LoveHappiness® All rights reserved.</p>
          </div>
          <div className="made-with-text text-center">
            <a href="https://softorigin.co.uk/" rel="noreferrer" target="_blank">
              made with
              <em><img src={Heart} alt="heart icon" /></em>
              by{" "}
              <a>Soft Origin</a>
            </a>
          </div>
        </div>
        {/* <BackgroundSection /> */}
      </div>
    </>
  );
}

export default Footer;
